<template>
	<div class="geneandsnp">
		<Loading msg="loading" v-if="!isload" />
		<div class="gene_and_snp_inner" v-else>
      	<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
            <h1 class="inner_title">什么是基因与位点?</h1>
            <ul class="inner_info">
                <li class="info_detail">
                    <img src="../assets/images/chromosome_icon.png" class="detail_item detail_icon" alt="">
                    <div class="detail_item detail_desc">
                        <div class="detail_name">染色体</div>
                        <p class="detail_text">人类细胞核中有23对染色体，染色体是由DNA和组蛋白构成的。DNA是携带遗传信息的物质，具有双螺旋结构，并缠绕着组蛋白，形成高度螺旋的染色体。</p>
                    </div>
                </li>
                <li class="info_detail">
                    <img src="../assets/images/dna_icon.png" class="detail_item detail_icon" alt="">
                    <div class="detail_item detail_desc">
                        <div class="detail_name">基因</div>
                        <p class="detail_text">DNA很长，包含了大量的遗传信息，如果把一个细胞里的DNA拉直，长度大约为2米。基因是DNA上的片段，是基本的遗传单位。DNA本身无法被解读，需要通过这些功能性的片段(基因)来解读DNA的遗传信息。</p>
                    </div>
                </li>
                <li class="info_detail">
                    <img src="../assets/images/snp_icon.png" class="detail_item detail_icon" alt="">
                    <div class="detail_item detail_desc">
                        <div class="detail_name">位点</div>
                        <p class="detail_text">位点是DNA上碱基的位置信息，我们检测位点上的碱基种类，通过得出的基因型(碱基的组合)结果，就能反应出一个人的某种身体特征(易长痘、易生皱纹等)。</p>
                    </div>
                </li>
            </ul>
		
		</div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";

export default {
  name: "GeneAndSnp",
  data() {
    return {
	  isload: true
    };
  },

  created() {
    console.log("GeneAndSnp created", this);
  },
  methods: {
 
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.back_btn{
  position:fixed;
  top:30/50rem;
  left:0;
  z-index:99999;
  width:118/50rem;
  height:54/50rem;
}
.gene_and_snp_inner{
    padding:106/50rem 30/50rem 371/50rem;
    .inner_title{
        padding:0 0 75/50rem;
        font-size:44/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
    }
    .info_detail{
        padding-bottom:80/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-justify;
        .detail_item{
            .flex_0;
        }
        .detail_icon{
            width:150/50rem;
            height:150/50rem;
            .shadow;
            .border-radius(14/50rem);
        }
        .detail_desc{
            width:509/50rem;
            .detail_name{
                font-size:30/50rem;
                line-height:1em;
                font-weight:bold;
                color:@font-c-3;
                padding-bottom:14/50rem;
            }
            .detail_text{
                font-size:24/50rem;
                line-height:30/50rem;
                color:@font-c-3;
            }
        }
    }
}

</style>
